import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faBank, faRightLeft, faSignOut } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Logo from '../Logo/Logo';
import './Navbar.css';

const Navbar = ({ handleWhatsappClick, handleDashboardClick, handleBankClick, logout }) => {
    return (
        <nav className="Navbar">
            <div className="NavbarLeft">
                <Logo onClick={handleDashboardClick} />
            </div>
            <div className="NavbarCenter">
                <button className="NavButton" onClick={handleDashboardClick}>
                    <FontAwesomeIcon icon={faRightLeft} />                    <span>Transferências</span>
                </button>
                <button className="NavButton" onClick={handleWhatsappClick}>
                    <FontAwesomeIcon icon={faWhatsapp} />
                    <span>WhatsApp</span>
                </button>
                <button className="NavButton" onClick={handleBankClick}>
                    <FontAwesomeIcon icon={faBank} />
                    <span>Bancos</span>
                </button>
            </div>
            <div className="NavbarRight">
                <button className="NavButton" onClick={logout}>
                    <FontAwesomeIcon icon={faSignOut} />
                    <span>Sair</span>
                </button>
            </div>
        </nav>
    );
};

export default Navbar;

